<template>
  <div class="container-income-report" :style="cssVars()">
    <div class="custom-nav-block" :style="`padding-top:${topBarHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow>
        <template #left>
          <div style="display: flex; align-items: center" @click="handleBackPath">
            <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
            {{ $t('lang.MyBeans.k005') }}
          </div>
        </template>
      </van-nav-bar>
    </div>
    <div class="report-swipe">
      <swiper class="my-swiper" ref="mySwiper" :options="swiperOptions">
        <swiper-slide v-for="item in serviceAdvantageData" :key="item.id">
          <div class="card-box" :style="{ background: `url(${item.image})`, 'background-size': '100% 100%' }">
            <span class="card-title">{{ $t('lang.BaseCommon.k083') }}</span>
            <div class="card-beans">
              <i>{{ data.amount }}</i>
              <img :src="getMatchImg('beans')" alt="" />
            </div>
            <span class="card-time">{{ data.weekStart }}-{{ data.weekEnd }}</span>
          </div>
        </swiper-slide>
      </swiper>
    </div>

    <div class="report-list">
      <div class="list-item" @click="toPage(item.day)" v-for="item in listDay" :key="item">
        <div class="time">{{ item.day }}</div>
        <div class="beans">
          <span>{{ item.amount }}</span>
          <img :src="getMatchImg('beans')" alt="" />
          <img class="date-arrow" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiFetchReport } from '@/api/imee'
import { getBaseFeature } from '@/assets/style/variable'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    const self = this
    return {
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
        },
        // 滑动时slide不动，释放鼠标或手指时slide切换
        followFinger: false,
        loop: false,
        // 设置平滑
        loopedSlides: 4,
        // 设置能够同时显示的数量（可设置 auto）
        slidesPerView: 'auto',
        // 设置能够同时显示的数量（可设置 auto）
        // slidesPerView: 2,
        centeredSlides: true,
        paginationClickable: true,
        // 间距
        spaceBetween: 0,
        // 切换速度
        speed: 500,
        autoplay: false,
        // 默认页
        initialSlide: 4,
        // 事件
        on: {
          slideChangeTransitionStart: function () {
            self.handleClickCard(this.activeIndex)
          },
        },
      },
      serviceAdvantageData: [
        {
          id: 0,
          image: require('@/assets/packageAssets/views/P1_Girls/MyBeans/default/report_bg1.webp'),
        },
        {
          id: 1,
          image: require('@/assets/packageAssets/views/P1_Girls/MyBeans/default/report_bg2.webp'),
        },
        {
          id: 2,
          image: require('@/assets/packageAssets/views/P1_Girls/MyBeans/default/report_bg3.webp'),
        },
        {
          id: 3,
          image: require('@/assets/packageAssets/views/P1_Girls/MyBeans/default/report_bg4.webp'),
        },
      ],
      // 当前时间
      nowTime: new Date().getTime(),
      data: {},
      listDay: [],
    }
  },
  created() {
    this.fetchReport()
  },
  methods: {
    cssVars() {
      return { ...getBaseFeature() }
    },
    handleBackPath() {
      this.goPrevious()
    },

    toPage(day) {
      this.$router.push({
        path: '/income/report/details',
        query: {
          date: day,
        },
      })
    },

    fetchReport() {
      apiFetchReport(this.nowTime).then((res) => {
        if (res) {
          this.data = res
          this.listDay = res.listDay
          this.nowTime = null
        }
      })
    },

    handleClickCard(index) {
      const weekTime = Number(7 * 24 * 60 * 60 * 1000)
      const now = Number(new Date().getTime())
      if (index == 0) {
        this.nowTime = now - weekTime * 3
      } else if (index == 1) {
        this.nowTime = now - weekTime * 2
      } else if (index == 2) {
        this.nowTime = now - weekTime * 1
      } else {
        this.nowTime = new Date().getTime()
      }
      this.fetchReport()
    },
  },
}
</script>
<style lang="scss" scoped>
// 样式层级与 template 一致：.container-income-report > .custom-nav-block | .report-swipe | .report-list
.container-income-report {
  width: 100%;
  min-height: 100vh;
  background: #fff;

  .custom-nav-block {
    ::v-deep .van-nav-bar__title {
      color: #000;
    }

    ::v-deep .van-nav-bar__left {
      color: #000;
    }
  }

  .report-swipe {
    .my-swiper {
      width: 100%;

      .swiper-slide {
        width: 90%;
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 12px;
        transition: 300ms;
        transform: scale(0.8);

        .card-box {
          position: relative;
          width: 100%;
          height: 162px;
          padding: 12px;
          border-radius: 20px;
          color: #ffffff;

          .card-title {
            font-family: var(--string-font);
            font-size: var(--fs-12);
            font-weight: var(--fw-500);
            line-height: var(--lh-label-16);
          }

          .card-beans {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            margin: 24px auto 10px;
            font-family: var(--number-font);
            font-size: var(--fs-32);
            font-weight: var(--fw-600);
            line-height: var(--lh-display-40);

            > img {
              width: 24px;
              margin-left: 4px;
            }
          }

          .card-time {
            display: block;
            width: 100%;
            font-family: var(--string-font);
            font-size: var(--fs-12);
            font-weight: var(--fw-400);
            line-height: var(--lh-label-16);
            text-align: center;
          }
        }
      }

      .swiper-slide-active,
      .swiper-slide-duplicate-active {
        transform: scale(1);
      }

      .swiper-slide-prev {
        position: relative;
        right: -90px !important;
      }

      .swiper-slide-next {
        position: relative;
        left: -90px !important;
      }
    }
  }

  .report-list {
    width: 100%;
    height: 52px;
    padding: 0 23px;
    margin-top: 30px;

    .list-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 100%;
      font-family: var(--string-font);
      font-size: var(--fs-14);
      font-weight: var(--fw-500);
      line-height: var(--lh-body-20);
      color: #333333;
      border-bottom: 1px solid #f9f9fb;

      &:first-child {
        border-top: 1px solid #f9f9fb;
      }

      .time {
        color: #666;
      }

      .beans {
        display: flex;
        align-items: center;

        > img {
          width: 14px;
          margin-left: 4px;
        }

        .date-arrow {
          width: 15px;
          transform: rotate(180deg);
        }
      }
    }
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .container-income-report .report-list .list-item .beans .date-arrow {
    transform: rotateY(0deg);
  }
}
</style>
